import Navbar from "../../../components/dashboard/navbar/Navbar"
import Overview from "../../../components/dashboard/overview/Overview"
import OverviewTest from "../../../components/dashboard/overview/OverviewTest"
import Sidebar from "../../../components/dashboard/sidebar/Sidebar"
import styles from "../layout.module.css"

import { selectSideNavOpen } from "../../../redux/slices/sharedSlice"
import { toggleSideNav } from "../../../redux/slices/sharedSlice"
import { useSelector } from "react-redux";
import { useState } from "react";

const OverviewPage = () => {

    const open = useSelector(selectSideNavOpen)

    return (
        <section className={styles.pageContainer}>
            <div className={`${open ? styles.leftBarOpen : styles.leftBarClosed}`}>
                <Sidebar />
            </div>
            <div className={`${open ? styles.rightBarOpen : styles.rightBarClosed}`}>
                <Navbar page="Overview" />
                <div className={styles.mainBar}>
                    {/* <Overview /> */}
                    <OverviewTest />
                </div>
            </div>
        </section>
    )
}
// 
export default OverviewPage